import VerifyCode from './Index.vue'

VerifyCode.install = function(Vue) {
  Vue.component(VerifyCode.name, VerifyCode)
}

export default VerifyCode
